import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["id", "children", "className", "body", "style", "autoHide", "theme", "placement", "offset", "containerClassName", "delay", "fullWidth", "innerClassName"];
import React, { useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import StrapTooltip from 'reactstrap/lib/Tooltip';
import { uuid } from '@guestyci/foundation/utils/commonUtility';
import { Theme } from '@guestyci/foundation/enums/enums';

var Tooltip = function Tooltip(_ref) {
  var id = _ref.id,
      children = _ref.children,
      className = _ref.className,
      body = _ref.body,
      style = _ref.style,
      autoHide = _ref.autoHide,
      theme = _ref.theme,
      placement = _ref.placement,
      offset = _ref.offset,
      containerClassName = _ref.containerClassName,
      delay = _ref.delay,
      fullWidth = _ref.fullWidth,
      innerClassName = _ref.innerClassName,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var onToggle = useCallback(function () {
    setIsOpen(!isOpen);
  }, [isOpen]);
  var tooltipId = useMemo(function () {
    return id || uuid();
  }, [id]);
  return body ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: containerClassName,
    id: "Tooltip-".concat(tooltipId)
  }, children), /*#__PURE__*/React.createElement(StrapTooltip, _extends({
    innerClassName: cn('font-size-md text-left border-radius-2', {
      'mw-100': fullWidth
    }, innerClassName),
    target: "Tooltip-".concat(tooltipId),
    isOpen: isOpen && !!body,
    toggle: onToggle,
    className: cn({
      'light-theme': theme === Theme.Light
    }, {
      'error-theme': theme === Theme.Error
    }, className),
    popperClassName: "zindex-1500",
    style: style,
    autohide: autoHide,
    placement: placement,
    offset: offset,
    delay: delay
  }, props), body)) : children;
};

Tooltip.defaultProps = {
  className: '',
  id: undefined,
  autoHide: true,
  theme: 'dark',
  placement: 'top',
  offset: undefined,
  containerClassName: '',
  body: null,
  delay: {
    show: 250,
    hide: 0
  },
  fullWidth: false,
  innerClassName: ''
};
Tooltip.propTypes = {
  /** Node - the component wrapped by the tooltip */
  children: PropTypes.node.isRequired,

  /** String || React Element - The tooltip body */
  body: PropTypes.node,

  /** String - Set the tooltip trigger id */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** String - Additional tooltip component class */
  className: PropTypes.string,

  /** String - Additional tooltip component class */
  containerClassName: PropTypes.string,

  /** Set tooltip to not hide on mouseleave tooltip element */
  autoHide: PropTypes.bool,

  /** Set the theme for the tooltip */
  theme: PropTypes.oneOf(['dark', 'light', 'error']),

  /** Popover placement supporting (top, bottom, left, right ) => <pos>-start, <pos>-end */
  placement: PropTypes.string,

  /** set custom offset to tooltip arrow */
  offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Set show/hide delay for dialog - structure {show, hide} or number */
  delay: PropTypes.oneOfType([PropTypes.shape({
    show: PropTypes.number,
    hide: PropTypes.number
  }), PropTypes.number]),

  /** Bool, if the tooltip with take max width or be contained */
  fullWidth: PropTypes.bool,

  /** Inner tooltip class name */
  innerClassName: PropTypes.string
};
export default Tooltip;